import React, { useEffect, useState } from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { NetworkMonitor } from '../lib/errors/retryHandler';

export const NetworkStatus: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showStatus, setShowStatus] = useState(false);
  const [isReconnecting, setIsReconnecting] = useState(false);

  useEffect(() => {
    const monitor = NetworkMonitor.getInstance();
    
    const unsubscribe = monitor.subscribe((online) => {
      setIsOnline(online);
      setShowStatus(true);
      
      if (online) {
        setIsReconnecting(false);
        // Hide success message after 3 seconds
        setTimeout(() => setShowStatus(false), 3000);
      }
    });

    return unsubscribe;
  }, []);

  const handleReconnect = async () => {
    setIsReconnecting(true);
    try {
      // Try to fetch a small resource to check connection
      await fetch('/favicon.ico', { method: 'HEAD' });
      setIsOnline(true);
      setShowStatus(false);
    } catch {
      // Still offline
      setIsOnline(false);
    }
    setIsReconnecting(false);
  };

  if (!showStatus || isOnline) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className={`
        flex items-center space-x-3 px-4 py-3 rounded-lg shadow-lg
        ${isOnline 
          ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200' 
          : 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200'
        }
      `}>
        {isOnline ? (
          <>
            <Wifi className="w-5 h-5" />
            <span className="text-sm font-medium">Bağlantı yeniden kuruldu</span>
          </>
        ) : (
          <>
            <WifiOff className="w-5 h-5" />
            <span className="text-sm font-medium">İnternet bağlantısı yok</span>
            <button
              onClick={handleReconnect}
              disabled={isReconnecting}
              className={`
                ml-2 flex items-center px-2 py-1 text-xs font-medium rounded
                bg-red-200 dark:bg-red-800 hover:bg-red-300 dark:hover:bg-red-700
                disabled:opacity-50 disabled:cursor-not-allowed
                transition-colors
              `}
            >
              <RefreshCw className={`w-3 h-3 mr-1 ${isReconnecting ? 'animate-spin' : ''}`} />
              Tekrar Dene
            </button>
          </>
        )}
      </div>
    </div>
  );
};

// Hook for network status
export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const monitor = NetworkMonitor.getInstance();
    const unsubscribe = monitor.subscribe(setIsOnline);
    return unsubscribe;
  }, []);

  return isOnline;
}